export default "/_next/static/chunks/fonts/Outfit Bold-b2e2fcd8bc0c090b302cf0c162805628.ttf";